import { useQuery } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { CouplePlanningController } from 'src/controllers/couple-planning.controller'
import { CouplePlanningDto } from 'src/dto/couple-planning.dto'

const couplePlanningController = new CouplePlanningController()

export function useGetCouplePlanningList() {
  const { userFarm: farmId } = useAuth()

  return useQuery<CouplePlanningDto[], Error>({
    queryKey: ['getCouplePlanningList', farmId],
    queryFn: () => couplePlanningController.getCouplePlanningList(farmId!),
    enabled: !!farmId
  })
}
